module.exports = __webpack_public_path__ + "media/images/solo-250-new@2x-ce4c9350c01b96b639e39690df2c9eea.webp";